<template>
  <div :class="classes">
    <div :class="$style.check">
      <transition name="bounce-center">
        <svg v-if="item.ready && item.size !== 's'" width="19" height="15" viewBox="0 0 19 15" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1 7.5L6.5 13L18 1.5" stroke="white" stroke-width="2"/>
        </svg>
      </transition>
    </div>
    <span>{{item.title}}</span>
  </div>
</template>
<script>
export default {
  name: 'check',
  props: {
    item: Object,
  },
  computed: {
    classes() {
      const { $style } = this
      const {
        size, ready, current,
      } = this.item

      return [
        $style.wrapper,
        size === 's' && $style.small,
        ready && $style.ready,
        current && $style.current,
      ]
    },
  },
}
</script>
<style lang="scss" module>
.wrapper {
  display: flex;
  align-items: center;
  font-size: 1.8rem;
  line-height: 1;

  & + & {
    margin-top: 2rem;
  }
}

.check {
  flex-shrink: 0;
  width: 3rem;
  height: 3rem;
  margin-right: 2rem;
  border: 0.2rem solid #F0F0F5;
  position: relative;

  svg {
    width: 1.9rem;
    height: auto;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}

.small {
  font-size: 1.6rem;
  margin-left: 5rem;

  .check {
    width: 1.2rem;
    height: 1.2rem;
    border-radius: 50%;
    border: 1px solid #000000;
  }
}

.ready {
  color: #09E56E;
  .check {
    background: #09E56E;
    border-color: #09E56E;
  }
}

.current {
  color: #09E56E;

  .check {
    border-color: #09E56E;
  }
}
</style>
